import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "@kui/foundations-react";
import "../../styles/kui-base.css";

/**
 * @description Full-page loading state using the same Kaizen Spinner as the
 * RWA app, so the loader looks identical across both applications.
 */
function PageLoading({ message }) {
  return (
    <div
      className="kui-scope"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spinner slotDescription={message} />
    </div>
  );
}

PageLoading.defaultProps = {
  message: "Loading",
};

PageLoading.propTypes = {
  message: PropTypes.string,
};

export default PageLoading;
